import React from 'react'
import {defineMessage, FormattedMessage, useIntl} from 'react-intl'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {BRAND_KEY} from '../brand'
import {useLocation} from 'react-router'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const useProductRegistrationData = () => {
    const location = useLocation()
    const {customParams} = getConfig()
    const currentPath = 'https://' + customParams.currentHost + location.pathname
    const intl = useIntl()

    let skuImage

    switch (BRAND_KEY) {
        case 'kenwood':
            skuImage = getAssetUrl(`static/img/product-registration/skuImage-kenwood.png`)
            break
        case 'braun':
            skuImage = getAssetUrl(`static/img/product-registration/skuImage-braun.png`)
            break
        default: // delonghi image is fallback
            skuImage = getAssetUrl(`static/img/product-registration/skuImage-delonghi.png`)
    }

    let modelNumberImage

    switch (BRAND_KEY) {
        case 'kenwood':
            modelNumberImage = getAssetUrl(
                `static/img/product-registration/modelNumber-kenwood.png`,
            )
            break
        case 'nutribullet':
            modelNumberImage = getAssetUrl(
                `static/img/product-registration/modelNumber-nutribullet.png`,
            )
            break
        case 'braun':
            modelNumberImage = getAssetUrl(`static/img/product-registration/modelNumber-braun.png`)
            break
        default: // delonghi image is fallback
            modelNumberImage = getAssetUrl(
                `static/img/product-registration/modelNumber-delonghi.png`,
            )
    }

    const skuTitle = (
        <FormattedMessage
            id="product_registration.sku_title"
            defaultMessage="Where can i find the SKU code?"
        />
    )
    const skuDescription = (
        <FormattedMessage
            id="product_registration.sku_description"
            defaultMessage="You can find the SKU code on the box of your product, usually on the long side at the top left."
        />
    )
    const modelTitle = (
        <FormattedMessage
            id="product_registration.model_title"
            defaultMessage="Where can i find the Model Number?"
        />
    )
    const modelDescription = (
        <FormattedMessage
            id="product_registration.model_description"
            defaultMessage="You can find the Model Number am auctor eget quam vitae fringilla. Have a different model? Search for it <u>here</u>."
            values={{
                u: (chunks) => (
                    <u>
                        <a
                            href="https://www.delonghi.com/it-it/support/find-serial-number"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {chunks}
                        </a>
                    </u>
                ),
            }}
        />
    )

    const productRegistrationTitleMessage = defineMessage({
        id: 'product_registration.title',
        defaultMessage: 'Register your product',
    })

    const productRegistrationSubtitleMessage = defineMessage({
        id: 'product_registration.subtitle',
        defaultMessage: 'Register your product to unlock a world of benefits.',
    })

    const webPageSchemaMarkup = {
        '@context': 'https://schema.org/',
        '@type': 'WebPage',
        name: intl.formatMessage(productRegistrationTitleMessage),
        description: intl.formatMessage(productRegistrationSubtitleMessage),
        url: currentPath,
    }

    return {
        skuImage,
        modelNumberImage,
        skuTitle,
        skuDescription,
        modelTitle,
        modelDescription,
        webPageSchemaMarkup,
    }
}
